if (!customElements.get("video-controls")) {
  customElements.define(
    "video-controls",
    class VideoControls extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.video = this.querySelector("video");
        this.hasVideoClickToggle =
          this.dataset.videoClick === "false" ? false : true;

        this.productsContainer = this.querySelector(
          ".shoppable-video__products"
        );
        this.controlButton = this.querySelector(
          ".shoppable-video__control-button"
        );
        this.muteButton = this.querySelector(
          ".video-unmute-btn"
        ); 

        // bind methods
        this.togglePlayPause = this.togglePlayPause.bind(this);
        this.toggleVideoIcon = this.toggleVideoIcon.bind(this);
        this.toggleMute = this.toggleMute.bind(this);
        this.updateMuteIcon = this.updateMuteIcon.bind(this);

        this.addEventListeners();

        if (this.controlButton && this.video) this.toggleVideoIcon();
        if (this.muteButton && this.video) this.updateMuteIcon();
      }

      addEventListeners() {
        if (this.controlButton)
          this.controlButton.addEventListener("click", this.togglePlayPause);
        if (this.video && this.hasVideoClickToggle)
          this.video.addEventListener("click", this.togglePlayPause);
        if (this.controlButton && this.video) {
          this.video.addEventListener("play", this.toggleVideoIcon);
          this.video.addEventListener("pause", this.toggleVideoIcon);
        }

        if (this.muteButton && this.video) {
          this.muteButton.addEventListener("click", this.toggleMute);
          this.video.addEventListener("volumechange", this.updateMuteIcon);
        }
      }

      removeEventListeners() {
        if (this.controlButton)
          this.controlButton.removeEventListener(
            "click",
            this.togglePlayPause
          );
        if (this.video && this.hasVideoClickToggle)
          this.video.removeEventListener("click", this.togglePlayPause);
        if (this.controlButton && this.video) {
          this.video.removeEventListener("play", this.toggleVideoIcon);
          this.video.removeEventListener("pause", this.toggleVideoIcon);
        }

        if (this.muteButton && this.video) {
          this.muteButton.removeEventListener("click", this.toggleMute);
          this.video.removeEventListener("volumechange", this.updateMuteIcon);
        }
      }

      toggleVideoIcon() {
        const isPlaying = !this.video.paused;
        this.controlButton.classList.toggle(
          "shoppable-video__control-button--play",
          isPlaying
        );
        this.controlButton.classList.toggle(
          "shoppable-video__control-button--pause",
          !isPlaying
        );
      }

      togglePlayPause(e) {
        e.preventDefault();
        if (!this.video) return;

        if (this.video.paused || this.video.ended) {
          this.video.play();
        } else {
          this.video.pause();
        }
      }

      toggleMute(e) {
        e.preventDefault();

        if (!this.video) return;

        this.video.muted = !this.video.muted;
        window.hasUserEnabledSound = true;
        this.updateMuteIcon();
      }

      updateMuteIcon() {
        if (!this.muteButton) return;

        if (this.video.muted) {
          this.muteButton.querySelector(".unmute").classList.add("hidden");
          this.muteButton.querySelector(".mute").classList.remove("hidden");
        } else {
          this.muteButton.querySelector(".unmute").classList.remove("hidden");
          this.muteButton.querySelector(".mute").classList.add("hidden");
        }
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }
    }
  );
}
